var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8358 23C16.6819 23 17.3742 22.3077 17.3742 21.4615H14.2973C14.2973 22.3077 14.9819 23 15.8358 23ZM20.4511 18.3846V14.5385C20.4511 12.1769 19.1896 10.2 16.9896 9.67692V9.15385C16.9896 8.51538 16.4742 8 15.8358 8C15.1973 8 14.6819 8.51538 14.6819 9.15385V9.67692C12.4742 10.2 11.2204 12.1692 11.2204 14.5385V18.3846L10.2281 19.3769C9.74344 19.8615 10.0819 20.6923 10.7665 20.6923H20.8973C21.5819 20.6923 21.9281 19.8615 21.4434 19.3769L20.4511 18.3846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBig);
export default __webpack_public_path__ + "static/media/Alert_Big.dfe5b9bc60c81c3464960baa5366ae07.svg";
export { ForwardRef as ReactComponent };